"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizePath = void 0;
var normalize_1 = require("./normalize");
Object.defineProperty(exports, "normalizePath", { enumerable: true, get: function () { return normalize_1.normalizePath; } });
//# sourceMappingURL=index.js.map